module.exports = __webpack_public_path__ + "assets/img/img-course1.0126f2e7.png";